import React from "react";
import { Link } from "react-router-dom";

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 40 }}>
    <h2 style={{
      color: "#f5c200",
      fontWeight: 800,
      fontSize: "1.1rem",
      textTransform: "uppercase",
      letterSpacing: "0.1em",
      marginBottom: 12,
      borderLeft: "4px solid #2a7a6f",
      paddingLeft: 14,
    }}>
      {title}
    </h2>
    <div style={{ color: "#ccc", fontSize: "0.95rem", lineHeight: 1.8 }}>
      {children}
    </div>
  </div>
);

const TableRow = ({ type, nom, finalite, duree, consentement }) => (
  <tr style={{ borderBottom: "1px solid #2a2a2a" }}>
    <td style={{ padding: "10px 12px", color: "#f7f4ee", fontWeight: 600 }}>{type}</td>
    <td style={{ padding: "10px 12px", color: "#ccc", fontFamily: "monospace", fontSize: "0.85rem" }}>{nom}</td>
    <td style={{ padding: "10px 12px", color: "#ccc" }}>{finalite}</td>
    <td style={{ padding: "10px 12px", color: "#aaa" }}>{duree}</td>
    <td style={{ padding: "10px 12px", textAlign: "center" }}>
      <span style={{
        background: consentement ? "#2a7a6f33" : "#f5c20022",
        color: consentement ? "#2a7a6f" : "#f5c200",
        border: `1px solid ${consentement ? "#2a7a6f" : "#f5c200"}`,
        borderRadius: 4,
        padding: "2px 8px",
        fontSize: "0.78rem",
        fontWeight: 700,
      }}>
        {consentement ? "Requis" : "Non requis"}
      </span>
    </td>
  </tr>
);

export default function PolitiqueCookies() {
  const handleResetConsent = () => {
    localStorage.removeItem("cookies_accepted");
    window.location.reload();
  };

  return (
    <div style={{ background: "#0d1117", minHeight: "100vh", paddingBottom: 80 }}>
      {/* Header de la page */}
      <div style={{
        background: "#1a1a1a",
        borderBottom: "3px solid #f5c200",
        padding: "60px 24px 40px",
        textAlign: "center",
      }}>
        <div style={{ fontSize: "2.5rem", marginBottom: 12 }}>🍪</div>
        <h1 style={{
          color: "#f7f4ee",
          fontWeight: 900,
          fontSize: "clamp(1.6rem, 4vw, 2.5rem)",
          marginBottom: 12,
        }}>
          Politique de Cookies
        </h1>
        <p style={{ color: "#aaa", fontSize: "0.95rem", maxWidth: 560, margin: "0 auto" }}>
          Dernière mise à jour : juin 2026 — Starting Five, Lomé, Togo
        </p>
      </div>

      {/* Contenu */}
      <div style={{ maxWidth: 860, margin: "0 auto", padding: "48px 24px" }}>

        <Section title="Qu'est-ce qu'un cookie ?">
          <p>
            Un cookie est un petit fichier texte déposé sur votre appareil (ordinateur, téléphone, tablette)
            lorsque vous visitez un site web. Il permet au site de mémoriser certaines informations sur votre
            visite, comme votre langue préférée ou vos préférences de navigation.
          </p>
          <p style={{ marginTop: 12 }}>
            Les cookies ne contiennent pas de virus et ne peuvent pas accéder aux fichiers présents sur votre appareil.
          </p>
        </Section>

        <Section title="Qui sommes-nous ?">
          <p>
            Ce site est édité par <strong style={{ color: "#f7f4ee" }}>Starting Five</strong>, situé à
            Cité Mokpokpo, Adidogomé Lomé, Togo. Pour toute question relative à notre utilisation des cookies,
            vous pouvez nous contacter à{" "}
            <a href="mailto:contact@startingfive.tg" style={{ color: "#2a7a6f" }}>
              contact@startingfive.tg
            </a>.
          </p>
        </Section>

        <Section title="Les cookies que nous utilisons">
          <p style={{ marginBottom: 20 }}>
            Nous utilisons trois catégories de cookies sur ce site :
          </p>

          {/* Tableau */}
          <div style={{ overflowX: "auto", borderRadius: 8, border: "1px solid #2a2a2a" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.9rem" }}>
              <thead>
                <tr style={{ background: "#1a1a1a" }}>
                  {["Type", "Nom", "Finalité", "Durée", "Consentement"].map((h) => (
                    <th key={h} style={{
                      padding: "12px",
                      color: "#f5c200",
                      fontWeight: 700,
                      fontSize: "0.78rem",
                      textTransform: "uppercase",
                      letterSpacing: "0.1em",
                      textAlign: "left",
                      borderBottom: "2px solid #333",
                    }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <TableRow
                  type="Essentiel"
                  nom="cookies_accepted"
                  finalite="Mémorise votre choix concernant les cookies"
                  duree="1 an"
                  consentement={false}
                />
                <TableRow
                  type="Essentiel"
                  nom="token (JWT)"
                  finalite="Maintien de votre session de connexion"
                  duree="Session"
                  consentement={false}
                />
                <TableRow
                  type="Analytique"
                  nom="_ga, _ga_XXXX"
                  finalite="Mesure d'audience via Google Analytics (pages vues, durée, provenance)"
                  duree="2 ans"
                  consentement={true}
                />
                <TableRow
                  type="Analytique"
                  nom="_gid"
                  finalite="Distingue les utilisateurs (Google Analytics)"
                  duree="24 heures"
                  consentement={true}
                />
              </tbody>
            </table>
          </div>
        </Section>

        <Section title="Cookies essentiels">
          <p>
            Ces cookies sont indispensables au bon fonctionnement du site. Ils permettent notamment de maintenir
            votre session connectée et de mémoriser votre choix de consentement aux cookies.
            <strong style={{ color: "#f7f4ee" }}> Ils ne peuvent pas être désactivés.</strong>
          </p>
        </Section>

        <Section title="Cookies analytiques (Google Analytics)">
          <p>
            Avec votre accord, nous utilisons Google Analytics pour comprendre comment vous utilisez notre site :
            quelles pages sont les plus visitées, d'où viennent nos visiteurs, combien de temps ils restent, etc.
            Ces données sont <strong style={{ color: "#f7f4ee" }}>anonymisées</strong> et nous aident à améliorer
            continuellement votre expérience.
          </p>
          <p style={{ marginTop: 12 }}>
            Google peut traiter ces données conformément à sa propre{" "}
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#2a7a6f" }}
            >
              politique de confidentialité
            </a>.
          </p>
          <p style={{ marginTop: 12 }}>
            Vous pouvez également désactiver Google Analytics sur tous les sites en installant l'extension officielle :{" "}
            <a
              href="https://tools.google.com/dlpage/gaoptout"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#2a7a6f" }}
            >
              Module de désactivation de Google Analytics
            </a>.
          </p>
        </Section>

        <Section title="Comment gérer vos cookies ?">
          <p>Vous avez plusieurs façons de contrôler vos cookies :</p>

          <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 12 }}>
            {[
              {
                title: "Modifier votre choix sur ce site",
                desc: "Cliquez sur le bouton ci-dessous pour réinitialiser votre consentement. La bannière réapparaîtra.",
              },
              {
                title: "Via votre navigateur",
                desc: "Vous pouvez bloquer ou supprimer les cookies depuis les paramètres de votre navigateur (Chrome, Firefox, Safari, Edge). Notez que désactiver certains cookies peut affecter le fonctionnement du site.",
              },
            ].map((item, i) => (
              <div key={i} style={{
                background: "#1a1a1a",
                border: "1px solid #2a2a2a",
                borderRadius: 8,
                padding: "16px 20px",
              }}>
                <div style={{ color: "#f7f4ee", fontWeight: 700, marginBottom: 6 }}>{item.title}</div>
                <div style={{ color: "#aaa", fontSize: "0.9rem" }}>{item.desc}</div>
              </div>
            ))}
          </div>

          <button
            onClick={handleResetConsent}
            style={{
              marginTop: 24,
              background: "transparent",
              border: "2px solid #f5c200",
              color: "#f5c200",
              padding: "10px 24px",
              borderRadius: 8,
              fontWeight: 700,
              fontSize: "0.9rem",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
            onMouseEnter={e => {
              e.target.style.background = "#f5c200";
              e.target.style.color = "#0d1117";
            }}
            onMouseLeave={e => {
              e.target.style.background = "transparent";
              e.target.style.color = "#f5c200";
            }}
          >
            🔄 Modifier mon choix de cookies
          </button>
        </Section>

        <Section title="Modifications de cette politique">
          <p>
            Nous pouvons mettre à jour cette politique de cookies à tout moment. Toute modification sera
            publiée sur cette page avec une date de mise à jour révisée. Nous vous encourageons à consulter
            régulièrement cette page.
          </p>
        </Section>

        <Section title="Contact">
          <p>
            Pour toute question sur notre utilisation des cookies ou pour exercer vos droits, contactez-nous :
          </p>
          <div style={{
            marginTop: 16,
            background: "#1a1a1a",
            border: "1px solid #2a2a2a",
            borderRadius: 8,
            padding: "20px 24px",
            display: "inline-block",
          }}>
            <div style={{ color: "#f7f4ee", fontWeight: 700, marginBottom: 8 }}>Starting Five</div>
            <div style={{ color: "#aaa", fontSize: "0.9rem", lineHeight: 2 }}>
              📧 contact@startingfive.tg<br />
              📞 +228 90 47 87 25<br />
              📍 Cité Mokpokpo, Adidogomé Lomé, Togo
            </div>
          </div>
        </Section>

        {/* Retour */}
        <div style={{ marginTop: 48, textAlign: "center" }}>
          <Link to="/" style={{
            color: "#2a7a6f",
            textDecoration: "none",
            fontWeight: 600,
            fontSize: "0.95rem",
          }}>
            ← Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
}